// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        this
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"3a957":[function(require,module,exports) {
require("a1fa53677ebe44").register(require("a18a796404d7dc6b").getBundleURL("9Doy9"), JSON.parse('["9Doy9","index.7ec4c110.js","dav9F","login.f08d4861.js","br0v5","login.285ce660.js","5kSNc","login.fb85d083.js","c6gGW","login.de7b2e2b.js","4awM2","login.53cbd2b4.css","3IKxD","login.06a12702.css","jexqz","dashboard.4718e345.js","5OD5n","image-grid.2c9c8f93.js","22bFH","image-grid.ffce55f1.css","gnXmb","table-custom.13ad73b7.js","zF5jF","table-custom.2c5074cd.js","j8MGX","table-custom.cd5bb043.js","awy4L","table-custom.773b39b3.js","lxu1o","table-custom.267471f4.js","9RfK3","table-custom.b702cdf6.css","7aFw8","data.ae1a27e5.js","7sdsO","side-panel.57dd384c.js","jmvyH","side-panel.0f5f7d39.css","e5dot","table.802907c5.js","jjzds","table.9a2866ad.css","ccxMX","data.f8d33587.js","gVkNJ","data.4a4d85ac.js","3iTY0","media.3e5a0766.js","oRGHH","selectable.b559f3b1.js","73ZbU","selectable.37f1c99e.css","d5ezZ","video-player.73094a15.js","h3GSl","video-player.d0926fd2.css","8GT6e","media.3b214e93.js","8Adri","media.5dbdf130.css","kyVC1","presentations.8d8d6f1a.js","I0PJV","presentations.9c123462.css","gx5hs","settings.987ad41f.js","8O7bN","users.39cc5a41.js","3yDLn","dashboard.01443c46.js","5fRoV","dashboard.819fc2ae.css","6oYbK","index.7d24eee2.js","lyYCb","index.beb6541c.css"]'));

},{"a1fa53677ebe44":"1mRc1","a18a796404d7dc6b":"i0CQd"}],"1mRc1":[function(require,module,exports) {
"use strict";
var mapping = new Map();
function register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function resolve(id) {
    var resolved = mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
module.exports.register = register;
module.exports.resolve = resolve;

},{}],"i0CQd":[function(require,module,exports) {
"use strict";
var bundleURL = {};
function getBundleURLCached(id) {
    var value = bundleURL[id];
    if (!value) {
        value = getBundleURL();
        bundleURL[id] = value;
    }
    return value;
}
function getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return getBaseURL(matches[2]);
    }
    return "/";
}
function getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
exports.getBundleURL = getBundleURLCached;
exports.getBaseURL = getBaseURL;
exports.getOrigin = getOrigin;

},{}],"iAnh8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactDom = require("react-dom");
var _reactRouterDom = require("react-router-dom");
var _reactTransitionGroup = require("react-transition-group");
var _provider = require("./vendor/eui/src/components/provider");
// global context provider
var _contextprovider = require("./contextprovider");
var _contextproviderDefault = parcelHelpers.interopDefault(_contextprovider);
// components
var _loadingSpinner = require("./components/loading-spinner");
var _loadingSpinnerDefault = parcelHelpers.interopDefault(_loadingSpinner);
var _globalLoadingSpinner = require("./higher-order-components/global-loading-spinner");
var _globalLoadingSpinnerDefault = parcelHelpers.interopDefault(_globalLoadingSpinner);
var _globalToastsList = require("./higher-order-components/global-toasts-list");
var _globalToastsListDefault = parcelHelpers.interopDefault(_globalToastsList);
var _appScss = require("./styles/app.scss");
// define routes content components
var _jsxRuntime = require("react/jsx-runtime");
// routes
const Login = /*#__PURE__*/ (0, _reactDefault.default).lazy(()=>require("c6c30bbaeb9e6cf2"));
const Dashboard = /*#__PURE__*/ (0, _reactDefault.default).lazy(()=>require("9cef951457020efd"));
const PAGES = [
    {
        path: "/",
        Component: Login
    },
    {
        path: "/*",
        Component: Dashboard
    }
];
class App extends (0, _reactDefault.default).Component {
    render() {
        // TODO: set appropriately for this project
        // optivar:g: [
        //   'product_basename',
        //   'product_name',
        //   'product_fullname',
        //   'company_name',
        //   'company_website',
        //
        //   'api_msgpack',
        //   'use_webp',
        //   'max_filesize',
        //   'html_output_num_rows',
        //  ]
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _provider.EuiProvider), {
            colorMode: "dark",
            modify: {
                colors: {
                    DARK: {
                        primary: "#19c9c8" // $wonderscore-color-blue-martina
                    }
                },
                font: {
                    family: "'Axiforma', 'Verdana', sans-serif"
                }
            },
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.BrowserRouter), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _contextproviderDefault.default), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _react.Suspense), {
                            fallback: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loadingSpinnerDefault.default), {
                                isVisible: true,
                                obscure: true
                            }),
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Switch), {
                                children: PAGES.map(({ path, Component })=>{
                                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                                        path: path,
                                        exact: true,
                                        children: ({ match })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTransitionGroup.CSSTransition), {
                                                in: match !== null,
                                                timeout: 250,
                                                classNames: "app",
                                                unmountOnExit: true,
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "app",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {})
                                                })
                                            })
                                    }, path);
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _globalLoadingSpinnerDefault.default), {}),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _globalToastsListDefault.default), {})
                    ]
                })
            })
        });
    }
}
(0, _reactDom.render)(/*#__PURE__*/ (0, _reactDefault.default).createElement(App, null), document.body.querySelector("#app"));

},{"react":"8WAed","react-dom":"eCBet","react-router-dom":"gKELy","react-transition-group":"boOTz","./vendor/eui/src/components/provider":"5eJN2","./contextprovider":"9zcL4","c6c30bbaeb9e6cf2":"ivmT4","9cef951457020efd":"7Hpbr","./components/loading-spinner":"foxlT","./higher-order-components/global-loading-spinner":"4npSU","./higher-order-components/global-toasts-list":"iRkHq","./styles/app.scss":"5MCO3","react/jsx-runtime":"j06vh","@parcel/transformer-js/src/esmodule-helpers.js":"V6veN"}],"ivmT4":[function(require,module,exports) {
module.exports = Promise.all([
    require("5f0efe84d9b2b11a")(require("a6ec7a3522f32ef4").resolve("3IKxD")),
    require("5f0efe84d9b2b11a")(require("a6ec7a3522f32ef4").resolve("4awM2")),
    require("ebd5c38a3c50ec68")(require("a6ec7a3522f32ef4").resolve("c6gGW")),
    require("ebd5c38a3c50ec68")(require("a6ec7a3522f32ef4").resolve("5kSNc")),
    require("ebd5c38a3c50ec68")(require("a6ec7a3522f32ef4").resolve("br0v5")),
    require("ebd5c38a3c50ec68")(require("a6ec7a3522f32ef4").resolve("dav9F"))
]).then(()=>module.bundle.root("6EvW2"));

},{"5f0efe84d9b2b11a":"VLNyQ","a6ec7a3522f32ef4":"1mRc1","ebd5c38a3c50ec68":"hOmb1"}],"VLNyQ":[function(require,module,exports) {
"use strict";
var cacheLoader = require("ae7c5e215a4907e2");
module.exports = cacheLoader(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        var existingLinks = document.getElementsByTagName("link");
        if ([].concat(existingLinks).some(function isCurrentBundle(link) {
            return link.href === bundle && link.rel.indexOf("stylesheet") > -1;
        })) {
            resolve();
            return;
        }
        var link = document.createElement("link");
        link.rel = "stylesheet";
        link.href = bundle;
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName("head")[0].appendChild(link);
    });
});

},{"ae7c5e215a4907e2":"fO3lV"}],"fO3lV":[function(require,module,exports) {
"use strict";
var cachedBundles = {};
var cachedPreloads = {};
var cachedPrefetches = {};
function getCache(type) {
    switch(type){
        case "preload":
            return cachedPreloads;
        case "prefetch":
            return cachedPrefetches;
        default:
            return cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

},{}],"hOmb1":[function(require,module,exports) {
"use strict";
var cacheLoader = require("ca2a84f7fa4a3bb0");
module.exports = cacheLoader(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName("script");
        if ([].concat(existingScripts).some(function isCurrentBundle(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement("link");
        preloadLink.href = bundle;
        preloadLink.rel = "preload";
        preloadLink.as = "script";
        document.head.appendChild(preloadLink);
        var script = document.createElement("script");
        script.async = true;
        script.type = "text/javascript";
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName("head")[0].appendChild(script);
    });
});

},{"ca2a84f7fa4a3bb0":"fO3lV"}],"7Hpbr":[function(require,module,exports) {
module.exports = Promise.all([
    require("a231bdba7114c01")(require("1217840c6fa35272").resolve("5fRoV")),
    require("936e708607a17f99")(require("1217840c6fa35272").resolve("3yDLn")),
    require("a231bdba7114c01")(require("1217840c6fa35272").resolve("4awM2")),
    require("936e708607a17f99")(require("1217840c6fa35272").resolve("c6gGW")),
    require("936e708607a17f99")(require("1217840c6fa35272").resolve("5kSNc")),
    require("936e708607a17f99")(require("1217840c6fa35272").resolve("br0v5")),
    require("936e708607a17f99")(require("1217840c6fa35272").resolve("jexqz"))
]).then(()=>module.bundle.root("7J7MQ"));

},{"a231bdba7114c01":"VLNyQ","1217840c6fa35272":"1mRc1","936e708607a17f99":"hOmb1"}],"iRkHq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _globalToastList = require("../../vendor/eui/src/components/toast/global_toast_list");
var _constants = require("../../constants");
var _context = require("../../context");
var _jsxRuntime = require("react/jsx-runtime");
class GlobalToastsList extends (0, _reactDefault.default).Component {
    render() {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _globalToastList.EuiGlobalToastList), {
            side: "left",
            dismissToast: this.props.context.removeToast,
            toasts: this.props.context.toasts,
            toastLifeTimeMs: (0, _constants.TOAST_DURATION_IMPORTANT)
        });
    }
}
exports.default = (0, _context.withAppContext)(GlobalToastsList);

},{"react":"8WAed","../../vendor/eui/src/components/toast/global_toast_list":"iTOIs","../../constants":"ig6N4","../../context":"1gM4M","react/jsx-runtime":"j06vh","@parcel/transformer-js/src/esmodule-helpers.js":"V6veN"}],"iTOIs":[function(require,module,exports) {
/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0 and the Server Side Public License, v 1; you may not use this file except
 * in compliance with, at your election, the Elastic License 2.0 or the Server
 * Side Public License, v 1.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SIDES", ()=>SIDES);
parcelHelpers.export(exports, "TOAST_FADE_OUT_MS", ()=>TOAST_FADE_OUT_MS);
parcelHelpers.export(exports, "EuiGlobalToastList", ()=>EuiGlobalToastList);
var _jsxRuntime = require("@emotion/react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _common = require("../common");
var _services = require("../../services");
var _time = require("../../services/time");
var _globalToastListItem = require("./global_toast_list_item");
var _toast = require("./toast");
var _globalToastListStyles = require("./global_toast_list.styles");
const sideToClassNameMap = {
    left: "euiGlobalToastList--left",
    right: "euiGlobalToastList--right"
};
const SIDES = (0, _common.keysOf)(sideToClassNameMap);
const TOAST_FADE_OUT_MS = 250;
const EuiGlobalToastList = ({ className, toasts = [], dismissToast: dismissToastProp, toastLifeTimeMs, side = "right", ...rest })=>{
    const [toastIdToDismissedMap, setToastIdToDismissedMap] = (0, _react.useState)({});
    const [toastToDismiss, setToastToDismiss] = (0, _react.useState)();
    const prevToasts = (0, _react.useRef)([]);
    const dismissTimeoutIds = (0, _react.useRef)([]);
    const toastIdToTimerMap = (0, _react.useRef)({});
    const isScrollingToBottom = (0, _react.useRef)(false);
    const isScrolledToBottom = (0, _react.useRef)(true);
    const isUserInteracting = (0, _react.useRef)(false);
    // See [Return Value](https://developer.mozilla.org/en-US/docs/Web/API/Window/requestAnimationFrame#Return_value)
    // for information on initial value of 0
    const isScrollingAnimationFrame = (0, _react.useRef)(0);
    const startScrollingAnimationFrame = (0, _react.useRef)(0);
    const listElement = (0, _react.useRef)(null);
    const euiTheme = (0, _services.useEuiTheme)();
    const styles = (0, _globalToastListStyles.euiGlobalToastListStyles)(euiTheme);
    const cssStyles = [
        styles.euiGlobalToastList,
        styles[side]
    ];
    const startScrollingToBottom = ()=>{
        isScrollingToBottom.current = true;
        const scrollToBottom = ()=>{
            // Although we cancel the requestAnimationFrame in componentWillUnmount,
            // it's possible for this.listElement to become null in the meantime
            if (!listElement.current) return;
            const position = listElement.current.scrollTop;
            const destination = listElement.current.scrollHeight - listElement.current.clientHeight;
            const distanceToDestination = destination - position;
            if (distanceToDestination < 5) {
                listElement.current.scrollTop = destination;
                isScrollingToBottom.current = false;
                isScrolledToBottom.current = true;
                return;
            }
            listElement.current.scrollTop = position + distanceToDestination * 0.25;
            if (isScrollingToBottom) isScrollingAnimationFrame.current = window.requestAnimationFrame(scrollToBottom);
        };
        startScrollingAnimationFrame.current = window.requestAnimationFrame(scrollToBottom);
    };
    const onMouseEnter = ()=>{
        // Stop scrolling to bottom if we're in mid-scroll, because the user wants to interact with
        // the list.
        isScrollingToBottom.current = false;
        isUserInteracting.current = true;
        // Don't let toasts dismiss themselves while the user is interacting with them.
        for(const toastId in toastIdToTimerMap.current)if (toastIdToTimerMap.current.hasOwnProperty(toastId)) {
            const timer = toastIdToTimerMap.current[toastId];
            timer.pause();
        }
    };
    const onMouseLeave = ()=>{
        isUserInteracting.current = false;
        for(const toastId in toastIdToTimerMap.current)if (toastIdToTimerMap.current.hasOwnProperty(toastId)) {
            const timer = toastIdToTimerMap.current[toastId];
            timer.resume();
        }
    };
    const onScroll = ()=>{
        if (listElement.current) isScrolledToBottom.current = listElement.current.scrollHeight - listElement.current.scrollTop === listElement.current.clientHeight;
    };
    const dismissToast = (0, _react.useCallback)((toast)=>{
        // Remove the toast after it's done fading out.
        dismissTimeoutIds.current.push(window.setTimeout(()=>{
            setToastToDismiss(toast);
        }, TOAST_FADE_OUT_MS));
        setToastIdToDismissedMap((prev)=>({
                ...prev,
                [toast.id]: true
            }));
    }, []);
    const scheduleToastForDismissal = (0, _react.useCallback)((toast)=>{
        // Start fading the toast out once its lifetime elapses.
        toastIdToTimerMap.current[toast.id] = new (0, _time.Timer)(()=>dismissToast(toast), toast.toastLifeTimeMs != null ? toast.toastLifeTimeMs : toastLifeTimeMs);
    }, [
        dismissToast,
        toastLifeTimeMs
    ]);
    const scheduleAllToastsForDismissal = (0, _react.useCallback)(()=>{
        toasts.forEach((toast)=>{
            if (!toastIdToTimerMap.current[toast.id]) scheduleToastForDismissal(toast);
        });
    }, [
        scheduleToastForDismissal,
        toasts
    ]);
    const addListeners = ()=>{
        if (listElement.current) {
            listElement.current.addEventListener("scroll", onScroll);
            listElement.current.addEventListener("mouseenter", onMouseEnter);
            listElement.current.addEventListener("mouseleave", onMouseLeave);
        }
    };
    const removeListeners = ()=>{
        if (listElement.current) {
            listElement.current.removeEventListener("scroll", onScroll);
            listElement.current.removeEventListener("mouseenter", onMouseEnter);
            listElement.current.removeEventListener("mouseleave", onMouseLeave);
        }
    };
    // componentDidMount
    (0, _react.useEffect)(()=>{
        addListeners();
        // componentWillUnmount
        return ()=>{
            if (isScrollingAnimationFrame.current !== 0) window.cancelAnimationFrame(isScrollingAnimationFrame.current);
            if (startScrollingAnimationFrame.current !== 0) window.cancelAnimationFrame(startScrollingAnimationFrame.current);
            removeListeners();
            dismissTimeoutIds.current.forEach(clearTimeout); // eslint-disable-line react-hooks/exhaustive-deps
            for(const toastId in toastIdToTimerMap.current)if (toastIdToTimerMap.current.hasOwnProperty(toastId)) {
                const timer = toastIdToTimerMap.current[toastId]; // eslint-disable-line react-hooks/exhaustive-deps
                timer.clear();
            }
        };
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    // componentDidUpdate
    (0, _react.useEffect)(()=>{
        scheduleAllToastsForDismissal();
        if (!isUserInteracting.current) {
            // If the user has scrolled up the toast list then we don't want to annoy them by scrolling
            // all the way back to the bottom.
            if (isScrolledToBottom.current) {
                if (prevToasts.current.length < toasts.length) startScrollingToBottom();
            }
        }
        prevToasts.current = toasts;
    }, [
        toasts,
        scheduleAllToastsForDismissal
    ]);
    // Toast dismissal side effect
    // Ensure the callback has correct state by not enclosing it in `setTimeout`
    (0, _react.useEffect)(()=>{
        const toast = toastToDismiss;
        // Because this is triggered by a setTimeout, and because React does not guarantee when
        // state updates happen, it is possible to double-dismiss a toast
        // including by double-clicking the "x" button on the toast
        // so, first check to make sure we haven't already dismissed this toast
        if (toast && toastIdToTimerMap.current.hasOwnProperty(toast.id)) {
            dismissToastProp(toast);
            toastIdToTimerMap.current[toast.id].clear();
            delete toastIdToTimerMap.current[toast.id];
            setToastIdToDismissedMap((prev)=>{
                const toastIdToDismissedMap = {
                    ...prev
                };
                delete toastIdToDismissedMap[toast.id];
                return toastIdToDismissedMap;
            });
        }
    }, [
        toastToDismiss,
        dismissToastProp
    ]);
    const renderedToasts = toasts.map((toast)=>{
        const { text, toastLifeTimeMs, ...rest } = toast;
        const onClose = ()=>dismissToast(toast);
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _globalToastListItem.EuiGlobalToastListItem), {
            isDismissed: toastIdToDismissedMap[toast.id],
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toast.EuiToast), {
                onClose: onClose,
                onFocus: onMouseEnter,
                onBlur: onMouseLeave,
                ...rest,
                children: text
            })
        }, toast.id);
    });
    const classes = (0, _classnamesDefault.default)("euiGlobalToastList", className);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        "aria-live": "polite",
        role: "region",
        ref: listElement,
        css: cssStyles,
        className: classes,
        ...rest,
        children: renderedToasts
    });
};

},{"@emotion/react/jsx-runtime":"1B1I6","react":"8WAed","classnames":"kLg7q","../common":"cWi5f","../../services":"lL9vv","../../services/time":"fg28A","./global_toast_list_item":"9Mdgd","./toast":"a5xOx","./global_toast_list.styles":"dnlhe","@parcel/transformer-js/src/esmodule-helpers.js":"V6veN"}],"fg28A":[function(require,module,exports) {
/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0 and the Server Side Public License, v 1; you may not use this file except
 * in compliance with, at your election, the Elastic License 2.0 or the Server
 * Side Public License, v 1.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Timer", ()=>(0, _timer.Timer));
var _timer = require("./timer");

},{"./timer":"5ntop","@parcel/transformer-js/src/esmodule-helpers.js":"V6veN"}],"5ntop":[function(require,module,exports) {
/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0 and the Server Side Public License, v 1; you may not use this file except
 * in compliance with, at your election, the Elastic License 2.0 or the Server
 * Side Public License, v 1.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Timer", ()=>Timer);
class Timer {
    constructor(callback, timeMs){
        this.pause = ()=>{
            clearTimeout(this.id);
            this.id = undefined;
            this.timeRemaining = (this.finishTime || 0) - Date.now();
        };
        this.resume = ()=>{
            this.id = setTimeout(this.finish, this.timeRemaining);
            this.finishTime = Date.now() + (this.timeRemaining || 0);
            this.timeRemaining = undefined;
        };
        this.clear = ()=>{
            clearTimeout(this.id);
            this.id = undefined;
            this.callback = undefined;
            this.finishTime = undefined;
            this.timeRemaining = undefined;
        };
        this.finish = ()=>{
            if (this.callback) this.callback();
            this.clear();
        };
        // No need to set timeout for Infinity timeMs.
        this.id = timeMs !== Infinity ? setTimeout(this.finish, timeMs) : undefined;
        this.callback = callback;
        this.finishTime = Date.now() + timeMs;
        this.timeRemaining = undefined;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"V6veN"}],"9Mdgd":[function(require,module,exports) {
/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0 and the Server Side Public License, v 1; you may not use this file except
 * in compliance with, at your election, the Elastic License 2.0 or the Server
 * Side Public License, v 1.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EuiGlobalToastListItem", ()=>EuiGlobalToastListItem);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _services = require("../../services");
var _cloneElement = require("../../services/theme/clone_element");
var _globalToastListStyles = require("./global_toast_list.styles");
const EuiGlobalToastListItem = ({ children, className, isDismissed })=>{
    const euiTheme = (0, _services.useEuiTheme)();
    if (!children) return null;
    const styles = (0, _globalToastListStyles.euiGlobalToastListItemStyles)(euiTheme);
    const cssStyles = [
        styles.euiGlobalToastListItem,
        isDismissed && styles.dismissed
    ];
    const classes = (0, _classnamesDefault.default)("euiGlobalToastListItem", children.props.className, className);
    return (0, _cloneElement.cloneElementWithCss)(children, {
        ...children.props,
        className: classes,
        css: cssStyles
    });
};

},{"classnames":"kLg7q","../../services":"lL9vv","../../services/theme/clone_element":"2ZtMG","./global_toast_list.styles":"dnlhe","@parcel/transformer-js/src/esmodule-helpers.js":"V6veN"}],"dnlhe":[function(require,module,exports) {
/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0 and the Server Side Public License, v 1; you may not use this file except
 * in compliance with, at your election, the Elastic License 2.0 or the Server
 * Side Public License, v 1.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "euiGlobalToastListStyles", ()=>euiGlobalToastListStyles);
parcelHelpers.export(exports, "euiGlobalToastListItemStyles", ()=>euiGlobalToastListItemStyles);
var _react = require("@emotion/react");
var _globalStyling = require("../../global_styling");
const euiGlobalToastListStyles = (euiThemeContext)=>{
    const { euiTheme } = euiThemeContext;
    const euiToastWidth = euiTheme.base * 20;
    return {
        /**
     * 1. Allow list to expand as items are added, but cap it at the screen height.
     * 2. Allow some padding for shadow
     */ // Base
        euiGlobalToastList: (0, _react.css)`
      ${(0, _globalStyling.euiScrollBarStyles)(euiThemeContext)}
      display: flex;
      flex-direction: column;
      align-items: stretch;
      position: fixed;
      z-index: ${euiTheme.levels.toast};
      ${(0, _globalStyling.logicalCSS)("bottom", 0)};
      ${(0, _globalStyling.logicalCSS)("width", `${euiToastWidth + euiTheme.base * 5}px`)}; /* 2 */
      ${(0, _globalStyling.logicalCSS)("max-height", "100vh")}; /* 1 */
      ${(0, _globalStyling.logicalCSSWithFallback)("overflow-y", "auto")};

      // Hide the scrollbar entirely
      scrollbar-width: none;

      &::-webkit-scrollbar {
        ${(0, _globalStyling.logicalSizeCSS)(0, 0)};
      }

      // The top and bottom padding give height to the list creating a dead-zone effect
      // when there's no toasts in the list, meaning you can't click anything beneath it.
      // Only add the padding if there's content.
      &:not(:empty) {
        ${(0, _globalStyling.logicalCSS)("padding-left", euiTheme.size.base)};
        ${(0, _globalStyling.logicalCSS)("padding-right", euiTheme.size.base)};
        ${(0, _globalStyling.logicalCSS)("padding-vertical", euiTheme.size.base)};
      }

      ${(0, _globalStyling.euiBreakpoint)(euiThemeContext, [
            "xs",
            "s"
        ])} {
        &:not(:empty) {
          ${(0, _globalStyling.logicalCSS)("left", 0)};
          ${(0, _globalStyling.logicalCSS)("width", "100%")}; /* 1 */
        }
      }
    `,
        // Variants
        right: (0, _react.css)`
      &:not(:empty) {
        ${(0, _globalStyling.logicalCSS)("right", 0)};
        ${(0, _globalStyling.logicalCSS)("padding-left", `${euiTheme.base * 4}px`)}; /* 2 */
      }
      ${(0, _globalStyling.euiBreakpoint)(euiThemeContext, [
            "xs",
            "s"
        ])} {
        &:not(:empty) {
          ${(0, _globalStyling.logicalCSS)("padding-left", euiTheme.size.base)};
        }
      }
    `,
        left: (0, _react.css)`
      &:not(:empty) {
        ${(0, _globalStyling.logicalCSS)("left", 0)};
        ${(0, _globalStyling.logicalCSS)("padding-right", `${euiTheme.base * 4}px`)}; /* 2 */
      }
      ${(0, _globalStyling.euiBreakpoint)(euiThemeContext, [
            "xs",
            "s"
        ])} {
        &:not(:empty) {
          ${(0, _globalStyling.logicalCSS)("padding-right", euiTheme.size.base)};
        }
      }
    `
    };
};
const euiGlobalToastListItemStyles = ({ euiTheme })=>{
    const euiShowToast = (0, _react.keyframes)`
  from {
    transform: translateY(${euiTheme.size.l}) scale(.9);
    opacity: 0;
  }

  to {
    transform: translateY(0) scale(1);
    opacity: 1;
  }
`;
    return {
        // Base
        euiGlobalToastListItem: (0, _react.css)`
      ${(0, _globalStyling.logicalCSS)("margin-bottom", euiTheme.size.base)};
      animation: ${euiTheme.animation.normal} ${euiShowToast}
        ${euiTheme.animation.resistance};
      opacity: 1;

      &:first-child {
        // justify-content: flex-end interferes with overflowing content,
        // so we'll use this to push items to the bottom instead.
        ${(0, _globalStyling.logicalCSS)("margin-top", "auto")};
      }

      &:last-child {
        ${(0, _globalStyling.logicalCSS)("margin-bottom", 0)};
      }
    `,
        // States
        dismissed: (0, _react.css)`
      transition: opacity ${euiTheme.animation.normal};
      opacity: 0;
    `
    };
};

},{"@emotion/react":"fGzt6","../../global_styling":"j2mav","@parcel/transformer-js/src/esmodule-helpers.js":"V6veN"}],"a5xOx":[function(require,module,exports) {
/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0 and the Server Side Public License, v 1; you may not use this file except
 * in compliance with, at your election, the Elastic License 2.0 or the Server
 * Side Public License, v 1.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "COLORS", ()=>COLORS);
parcelHelpers.export(exports, "EuiToast", ()=>EuiToast);
var _jsxRuntime = require("@emotion/react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _services = require("../../services");
var _accessibility = require("../accessibility");
var _button = require("../button");
var _i18N = require("../i18n");
var _icon = require("../icon");
var _text = require("../text");
var _toastStyles = require("./toast.styles");
const COLORS = [
    "primary",
    "success",
    "warning",
    "danger"
];
const EuiToast = ({ title, color, iconType, onClose, children, className, ...rest })=>{
    const euiTheme = (0, _services.useEuiTheme)();
    const baseStyles = (0, _toastStyles.euiToastStyles)(euiTheme);
    const baseCss = [
        baseStyles.euiToast,
        color && baseStyles[color]
    ];
    const bodyStyles = (0, _toastStyles.euiToastBodyStyles)();
    const headerStyles = (0, _toastStyles.euiToastHeaderStyles)(euiTheme);
    const headerCss = [
        headerStyles.euiToastHeader,
        children && headerStyles.withBody
    ];
    const classes = (0, _classnamesDefault.default)("euiToast", className);
    let headerIcon;
    if (iconType) headerIcon = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icon.EuiIcon), {
        css: headerStyles.euiToastHeader__icon,
        type: iconType,
        size: "m",
        "aria-hidden": "true"
    });
    let closeButton;
    if (onClose) closeButton = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _i18N.EuiI18n), {
        token: "euiToast.dismissToast",
        default: "Dismiss toast",
        children: (dismissToast)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.EuiButtonIcon), {
                css: baseStyles.euiToast__closeButton,
                iconType: "cross",
                color: "text",
                size: "xs",
                "aria-label": dismissToast,
                onClick: onClose,
                "data-test-subj": "toastCloseButton"
            })
    });
    let optionalBody;
    if (children) optionalBody = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _text.EuiText), {
        css: bodyStyles.euiToastBody,
        size: "s",
        "data-test-subj": "euiToastBody",
        children: children
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        css: baseCss,
        className: classes,
        ...rest,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _accessibility.EuiScreenReaderOnly), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _i18N.EuiI18n), {
                        token: "euiToast.newNotification",
                        default: "A new notification appears"
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _i18N.EuiI18n), {
                token: "euiToast.notification",
                default: "Notification",
                children: (notification)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        css: headerCss,
                        "aria-label": notification,
                        "data-test-subj": "euiToastHeader",
                        children: [
                            headerIcon,
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                css: headerStyles.euiToastHeader__title,
                                "data-test-subj": "euiToastHeader__title",
                                children: title
                            })
                        ]
                    })
            }),
            closeButton,
            optionalBody
        ]
    });
};

},{"@emotion/react/jsx-runtime":"1B1I6","react":"8WAed","classnames":"kLg7q","../../services":"lL9vv","../accessibility":"VYfk0","../button":"3GknI","../i18n":"9zkg4","../icon":"l2cTy","../text":"lsB50","./toast.styles":"gQYkq","@parcel/transformer-js/src/esmodule-helpers.js":"V6veN"}],"VYfk0":[function(require,module,exports) {
/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0 and the Server Side Public License, v 1; you may not use this file except
 * in compliance with, at your election, the Elastic License 2.0 or the Server
 * Side Public License, v 1.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EuiScreenReaderLive", ()=>(0, _screenReaderLive.EuiScreenReaderLive));
parcelHelpers.export(exports, "EuiScreenReaderOnly", ()=>(0, _screenReaderOnly.EuiScreenReaderOnly));
parcelHelpers.export(exports, "euiScreenReaderOnly", ()=>(0, _screenReaderOnly.euiScreenReaderOnly));
parcelHelpers.export(exports, "EuiSkipLink", ()=>(0, _skipLink.EuiSkipLink));
var _screenReaderLive = require("./screen_reader_live");
var _screenReaderOnly = require("./screen_reader_only");
var _skipLink = require("./skip_link");

},{"./screen_reader_live":"assIF","./screen_reader_only":"vm3zq","./skip_link":false,"@parcel/transformer-js/src/esmodule-helpers.js":"V6veN"}],"assIF":[function(require,module,exports) {
/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0 and the Server Side Public License, v 1; you may not use this file except
 * in compliance with, at your election, the Elastic License 2.0 or the Server
 * Side Public License, v 1.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EuiScreenReaderLive", ()=>(0, _screenReaderLive.EuiScreenReaderLive));
var _screenReaderLive = require("./screen_reader_live");

},{"./screen_reader_live":"8n0fJ","@parcel/transformer-js/src/esmodule-helpers.js":"V6veN"}],"8n0fJ":[function(require,module,exports) {
/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0 and the Server Side Public License, v 1; you may not use this file except
 * in compliance with, at your election, the Elastic License 2.0 or the Server
 * Side Public License, v 1.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EuiScreenReaderLive", ()=>EuiScreenReaderLive);
var _jsxRuntime = require("@emotion/react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _screenReaderOnly = require("../screen_reader_only");
const EuiScreenReaderLive = ({ children, isActive = true, role = "status", "aria-live": ariaLive = "polite", focusRegionOnTextChange = false })=>{
    const [toggle, setToggle] = (0, _react.useState)(false);
    const focusRef = (0, _react.useRef)(null);
    (0, _react.useEffect)(()=>{
        setToggle((toggle)=>!toggle);
    }, [
        children
    ]);
    (0, _react.useEffect)(()=>{
        if (focusRef.current !== null && focusRegionOnTextChange) focusRef.current.focus();
    }, [
        toggle,
        focusRegionOnTextChange
    ]);
    return(/**
     * Intentionally uses two persistent live regions with oscillating content updates.
     * This resolves the problem of duplicate screen reader announcements in rapid succession
     * caused by React's virtual DOM behaviour (https://github.com/nvaccess/nvda/issues/7996#issuecomment-413641709)
     *
     * Adapted from https://github.com/alphagov/accessible-autocomplete/blob/a7106f03150941fc15e6c1ceb0a90e8872fa86ef/src/status.js
     * Debouncing was not needed for this case, but could prove to be useful for future use cases.
     * See also https://github.com/AlmeroSteyn/react-aria-live and https://github.com/dequelabs/ngA11y
     * for more examples of the double region approach.
     */ /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _screenReaderOnly.EuiScreenReaderOnly), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            ref: focusRef,
            tabIndex: focusRegionOnTextChange ? -1 : undefined,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    role: role,
                    "aria-atomic": "true",
                    // Setting `aria-hidden` and setting `aria-live` to "off" prevents
                    // double announcements from VO when `focusRegionOnTextChange` is true
                    "aria-hidden": toggle ? undefined : "true",
                    "aria-live": !toggle || focusRegionOnTextChange ? "off" : ariaLive,
                    children: isActive && toggle ? children : ""
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    role: role,
                    "aria-atomic": "true",
                    "aria-hidden": !toggle ? undefined : "true",
                    "aria-live": toggle || focusRegionOnTextChange ? "off" : ariaLive,
                    children: isActive && !toggle ? children : ""
                })
            ]
        })
    }));
};

},{"@emotion/react/jsx-runtime":"1B1I6","react":"8WAed","../screen_reader_only":"vm3zq","@parcel/transformer-js/src/esmodule-helpers.js":"V6veN"}],"vm3zq":[function(require,module,exports) {
/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0 and the Server Side Public License, v 1; you may not use this file except
 * in compliance with, at your election, the Elastic License 2.0 or the Server
 * Side Public License, v 1.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EuiScreenReaderOnly", ()=>(0, _screenReaderOnly.EuiScreenReaderOnly));
parcelHelpers.export(exports, "euiScreenReaderOnly", ()=>(0, _screenReaderOnlyStyles.euiScreenReaderOnly));
var _screenReaderOnly = require("./screen_reader_only");
var _screenReaderOnlyStyles = require("./screen_reader_only.styles");

},{"./screen_reader_only":"YT9Tb","./screen_reader_only.styles":"ba6gK","@parcel/transformer-js/src/esmodule-helpers.js":"V6veN"}],"YT9Tb":[function(require,module,exports) {
/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0 and the Server Side Public License, v 1; you may not use this file except
 * in compliance with, at your election, the Elastic License 2.0 or the Server
 * Side Public License, v 1.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EuiScreenReaderOnly", ()=>EuiScreenReaderOnly);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _cloneElement = require("../../../services/theme/clone_element");
var _screenReaderOnlyStyles = require("./screen_reader_only.styles");
const EuiScreenReaderOnly = ({ children, className, showOnFocus })=>{
    const classes = (0, _classnamesDefault.default)(className, children.props.className);
    const styles = (0, _screenReaderOnlyStyles.euiScreenReaderOnlyStyles)(showOnFocus);
    const cssStyles = [
        styles.euiScreenReaderOnly
    ];
    const props = {
        className: classes.length ? classes : undefined,
        css: cssStyles
    };
    return (0, _cloneElement.cloneElementWithCss)(children, props);
};

},{"classnames":"kLg7q","../../../services/theme/clone_element":"2ZtMG","./screen_reader_only.styles":"ba6gK","@parcel/transformer-js/src/esmodule-helpers.js":"V6veN"}],"gQYkq":[function(require,module,exports) {
/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0 and the Server Side Public License, v 1; you may not use this file except
 * in compliance with, at your election, the Elastic License 2.0 or the Server
 * Side Public License, v 1.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "euiToastStyles", ()=>euiToastStyles);
parcelHelpers.export(exports, "euiToastHeaderStyles", ()=>euiToastHeaderStyles);
parcelHelpers.export(exports, "euiToastBodyStyles", ()=>euiToastBodyStyles);
var _react = require("@emotion/react");
var _globalStyling = require("../../global_styling");
var _amsterdam = require("../../themes/amsterdam");
var _titleStyles = require("../title/title.styles");
const euiToastStyles = (euiThemeContext)=>{
    const { euiTheme } = euiThemeContext;
    return {
        // Base
        euiToast: (0, _react.css)`
      border-radius: ${euiTheme.border.radius.medium};
      ${(0, _amsterdam.euiShadowLarge)(euiThemeContext)};

      position: relative;
      ${(0, _globalStyling.logicalCSS)("padding-horizontal", euiTheme.size.base)};
      ${(0, _globalStyling.logicalCSS)("padding-vertical", euiTheme.size.base)};
      background-color: ${euiTheme.colors.emptyShade};
      ${(0, _globalStyling.logicalCSS)("width", "100%")};

      &:hover,
      &:focus {
        [class*='euiToast__closeButton'] {
          opacity: 1;
        }
      }
    `,
        // Elements
        euiToast__closeButton: (0, _react.css)`
      position: absolute;
      ${(0, _globalStyling.logicalCSS)("top", euiTheme.size.base)};
      ${(0, _globalStyling.logicalCSS)("right", euiTheme.size.base)};
    `,
        // Variants
        primary: (0, _react.css)`
      ${(0, _globalStyling.logicalCSS)("border-top", `2px solid ${euiTheme.colors.primary}`)}
    `,
        success: (0, _react.css)`
      ${(0, _globalStyling.logicalCSS)("border-top", `2px solid ${euiTheme.colors.success}`)}
    `,
        warning: (0, _react.css)`
      ${(0, _globalStyling.logicalCSS)("border-top", `2px solid ${euiTheme.colors.warning}`)}
    `,
        danger: (0, _react.css)`
      ${(0, _globalStyling.logicalCSS)("border-top", `2px solid ${euiTheme.colors.danger}`)}
    `
    };
};
const euiToastHeaderStyles = (euiThemeContext)=>{
    const { euiTheme } = euiThemeContext;
    return {
        // Base
        euiToastHeader: (0, _react.css)`
      // Account for close button.
      ${(0, _globalStyling.logicalCSS)("padding-right", euiTheme.size.l)};

      display: flex;

      // Align icon with first line of title text if it wraps.
      align-items: baseline;

      > * + * {
        // Apply margin to all but last item in the flex.
        ${(0, _globalStyling.logicalCSS)("margin-left", euiTheme.size.s)};
      }
    `,
        // Elements
        euiToastHeader__icon: (0, _react.css)`
      flex: 0 0 auto;
      fill: ${euiTheme.colors.title};

      // Vertically center icon with first line of title.
      transform: translateY(2px);
    `,
        euiToastHeader__title: (0, _react.css)`
      ${(0, _titleStyles.euiTitle)(euiThemeContext, "xs")};
      font-weight: ${euiTheme.font.weight.bold};

      // Custom
      font-size: 14px;
    `,
        // Variants
        withBody: (0, _react.css)`
      ${(0, _globalStyling.logicalCSS)("margin-bottom", euiTheme.size.s)};
    `
    };
};
const euiToastBodyStyles = ()=>({
        // Base
        euiToastBody: (0, _react.css)`
    word-wrap: break-word; // Prevent long lines from overflowing
  `
    });

},{"@emotion/react":"fGzt6","../../global_styling":"j2mav","../../themes/amsterdam":"i1ETQ","../title/title.styles":"kMAds","@parcel/transformer-js/src/esmodule-helpers.js":"V6veN"}],"5MCO3":[function() {},{}]},["3a957","iAnh8"], "iAnh8", "parcelRequirecd14")

//# sourceMappingURL=index.7ec4c110.js.map
